export default __webpack_public_path__ + "static/media/barcode.69190d05.svg";